import { render, staticRenderFns } from "./Mine.vue?vue&type=template&id=dd4b55e6&"
import script from "./Mine.vue?vue&type=script&lang=ts&"
export * from "./Mine.vue?vue&type=script&lang=ts&"
import style0 from "./Mine.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports